module.exports.general = {
  title: "Out of Balance",
  cities: ["Amsterdam", "Bangkok", "Bogotá", "Brussels", "Buenos Aires",
    "Cairo", "Chicago", "Copenhagen", "Dublin", "Frankfurt", "Geneva",
    "Helsinki", "Hong Kong", "Istanbul", "Jakarta", "Johannesburg",
    "Kuala Lumpur", "Lagos", "Lisbon", "London", "Los Angeles",
    "Luxembourg", "Madrid", "Milan", "Manila", "Mexico City",
    "Montreal", "Mumbai", "Nairobi", "New York", "Nikosia",
    "Oslo", "Paris", "Rio de Janeiro", "São Paulo", "Seoul",
    "Stockholm", "Sydney", "Tel Aviv", "Tokyo", "Toronto",
    "Vienna", "Zurich"], // took out Panama
  professions: [ // in SVG render direction
    {
      name: "Sales Assistant",
      id: "salesassistant",
      color: "FFD3A3"
    },
    {
      name: "Automobile Mechanic",
      id: "automobilemechanic",
      color: "FF856A"
    },
    {
      name: "Cook",
      id: "cook",
      color: "638ED5"
    },
    {
      name: "Primary School Teacher",
      id: "primaryschoolteacher",
      color: "8BD689"
    },
    {
      name: "Department Manager",
      id: "departmentmanager",
      color: "90734E"
    },
    {
      name: "GDP per Capita",
      id: "gdp",
      color: "000000"
    }
  ]
}

module.exports.pages = [
// 0 = landing
  {
    text: [
      {
        type: "h1",
        class: "title",
        string: "Out of Balance"
      },{
        type: "h2",
        class: "subtitle",
        string: "by Superdot Studio"
      }
    ],
    button: "Los geht’s!",
    city1: "no",
    city2: "no",
    story: "A data story on income disparities among five occupational groups in 40 cities",
    citynav: "no"
  },
// 1 = 5 professions
  {
    text: "no",
    city1: "no",
    city2: "no",
    story: "The five occupational groups",
    citynav: "no"
  },
// 2 = exemplary salaries
  {
    text: "no",
    city1: "Geneva",
    city2: "no",
    story: "The income gap using the example of the city of Geneva in U.S. dollars",
    citynav: "no"
  },
// 3 = bip
  {
    text: "no",
    city1: "Geneva",
    city2: "no",
    story: "In comparison, the monthly gross domestic product (GDP) per capita",
    citynav: "no"
  },
// 4 = explore: cities
  {
    city1: "explore",
    city2: "no",
    text: "no",
    story: "no",
    citynav: "one"
  },
// 5 = introduce: compare cities
  {
    story: "In 2018, the income gap was smallest in the Nigerian city of Lagos and largest in Luxembourg.",
    city1: "Lagos",
    city2: "Luxembourg",
    text: "no",
    citynav: "no"
  },
// 6 = explore: compare cities
  {
    city1: "explore",
    city2: "explore",
    text: "no",
    story: "no",
    citynav: "two"
  },
// 7 = introduce: compare 2018 vs. 1988
  {
    story: [
      "Between ",
      "1988",
      " and 2018, the income gap grew the most in São Paulo and shrank the most in Tokyo."
    ],
    city1: "São Paulo",
    city2: "Tokyo",
    text: "no",
    citynav: "no"
  },
// 8 = explore: compare 2018 vs. 1988
  {
    city1: "explore",
    city2: "explore",
    text: "no",
    story: "no",
    citynav: "two"
  },
// 9 = credits
  {
    title: "yes",
    text: [
      {
        type: "h1",
        class: "Credits title",
        string: "Out of Balance"
      },{
        type: "h2",
        class: "Credits subtitle",
        string: "by Superdot Studio"
      },{
        type: "span",
        class: "Credits",
        string: "This interactive data story is based on a "
        // string: "Diese interaktive Datenvisualisierung basiert auf einem Plakat-Projekt, das im Jahr 2013 im Rahmen eines Wettbewerbs erstellt wurde. Mehr zum Vorgängerprojekt auf "
      },{
        type: "a",
        class: "Credits",
        string: "poster project",
        // string: "Behance",
        url: "https://www.behance.net/gallery/23151677/Data-Visualization-on-Inequality-of-Society"
      },{
        type: "span",
        class: "Credits",
        string: " created in 2013 as part of a competition.",
        // string: ".",
        url: "https://www.behance.net/gallery/23151677/Data-Visualization-on-Inequality-of-Society"
      },{
        type: "h2",
        class: "Credits",
        string: ""
      },{
        type: "span",
        class: "Credits",
        string: "Source Salaries: "
      },{
        type: "a",
        class: "Credits",
        string: "UBS Prices and Earnings",
        url: "https://www.ubs.com/microsites/prices-earnings/en"
      },{
        type: "h2",
        class: "Credits tight",
        string: ""
      },{
        type: "span",
        class: "Credits",
        string: "Source GDP: "
      },{
        type: "a",
        class: "Credits",
        string: "Data Worldbank",
        url: "https://data.worldbank.org/indicator/NY.GDP.PCAP.CD"
      },{
        type: "p",
        class: "Credits dist",
        string: "",
      },{
        type: "a",
        class: "Credits",
        string: "Superdot.studio",
        url: "https://www.superdot.studio/"
      }
    ],
    city1: "no",
    city2: "no",
    story: "no",
    citynav: "no"
  }
]
